export default "__VITE_ASSET__00ccdea8__"